export const STORAGE_KEYS = {
  ANALYST_BANNER_HIDDEN: 'analystBannerHidden',
  MAPPING_MODAL_CLOSED_KEY: 'mappingModalClosed',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
